var _a;
export var UrlComparisonType;
(function (UrlComparisonType) {
    UrlComparisonType["CONTAINS_THE_STRING"] = "CONTAINS_THE_STRING";
    UrlComparisonType["DOESNT_CONTAIN_THE_STRING"] = "DOESNT_CONTAIN_THE_STRING";
    UrlComparisonType["STARTS_WITH"] = "STARTS_WITH";
    UrlComparisonType["DOESNT_START_WITH"] = "DOESNT_START_WITH";
    UrlComparisonType["IS_EXACTLY"] = "IS_EXACTLY";
})(UrlComparisonType || (UrlComparisonType = {}));
export var UrlComparisonTypeValue = (_a = {},
    _a[UrlComparisonType.CONTAINS_THE_STRING] = 'LEAD_GENERATION.URL_COMPARISON_TYPE.CONTAINS_THE_STRING',
    _a[UrlComparisonType.DOESNT_CONTAIN_THE_STRING] = 'LEAD_GENERATION.URL_COMPARISON_TYPE.DOESNT_CONTAIN_THE_STRING',
    _a[UrlComparisonType.STARTS_WITH] = 'LEAD_GENERATION.URL_COMPARISON_TYPE.STARTS_WITH',
    _a[UrlComparisonType.DOESNT_START_WITH] = 'LEAD_GENERATION.URL_COMPARISON_TYPE.DOESNT_START_WITH',
    _a[UrlComparisonType.IS_EXACTLY] = 'LEAD_GENERATION.URL_COMPARISON_TYPE.IS_EXACTLY',
    _a);
